import { render, staticRenderFns } from "./returnReason.vue?vue&type=template&id=09935bcd&scoped=true&"
import script from "./returnReason.vue?vue&type=script&lang=js&"
export * from "./returnReason.vue?vue&type=script&lang=js&"
import style0 from "./returnReason.vue?vue&type=style&index=0&id=09935bcd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09935bcd",
  null
  
)

export default component.exports